module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img5.7d543d0af17a33586a9a6f81c764cebc.jpg";